<template>
	<footer class="footer">
		© 2022 Jongkil Park.
	</footer>
</template>